import React from 'react';
import { FormApi } from 'final-form';

import { AwardType } from '@occc-app/offerHelpers/types';
import { OnChange } from '@occc/ui-forms';

import {
  defaultConstraintEnabledFieldName,
  defaultFieldNamePrefix,
} from './award-restrictions.constants';

type AwardRestrictionsAwardTypeWatcherProps = {
  awardTypeFieldName: string;
  form: FormApi<any>;
  fieldNamePrefix?: string;
  constraintIsEnabledFieldName?: string;
};
export const AwardRestrictionsAwardTypeWatcher = (
  props: AwardRestrictionsAwardTypeWatcherProps,
) => {
  const {
    awardTypeFieldName,
    form,
    fieldNamePrefix = defaultFieldNamePrefix,
    constraintIsEnabledFieldName = defaultConstraintEnabledFieldName,
  } = props;
  const isEnabledFieldName = `${fieldNamePrefix}.${constraintIsEnabledFieldName}`;
  return (
    <OnChange name={awardTypeFieldName}>
      {(awardType: AwardType) => {
        if (awardType !== AwardType.AwardVouchers) {
          form.mutators.setFieldValue(isEnabledFieldName, false);
        }
      }}
    </OnChange>
  );
};
